import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';
import { qs } from '@/behaviors/dom-utils.js';

const documentsCheckbox = (modal) => {
  const popupOpened = 600;
  const canPwf = modal.dataset.canPwf === 'true';
  const canSan = modal.dataset.canSan === 'true';
  const urlUpdatePwf = modal.dataset.togglepwf;
  const urlUpdateSan = modal.dataset.togglesan;
  const urlUpdateRiservato = modal.dataset.toggleriservato;

  setTimeout(() => {
    modal.querySelectorAll(".template-download input[type='checkbox']").forEach((el) => {
      el.addEventListener('click', async (ev) => {
        ev.preventDefault();
        const checkboxClassList = ev.target.classList;
        if (checkboxClassList.contains('documents_checkbox_updating')) return;

        checkboxClassList.add('documents_checkbox_updating');

        let url = '';
        if (checkboxClassList.contains('pwf') && canPwf) {
          url = urlUpdatePwf;
        } else if (checkboxClassList.contains('san') && canSan) {
          url = urlUpdateSan;
        } else if (checkboxClassList.contains('riservato')) {
          url = urlUpdateRiservato;
        }

        updateCheckbox(ev, url, modal);

        checkboxClassList.remove('documents_checkbox_updating');
      });
    });
  }, popupOpened);
};

const updateCheckbox = async (ev, url, modal) => {
  if (!url) return;
  try {
    const id = ev.target.dataset.documentId;
    const response = await apiConnector().put(`${url}.json`, { id: ev.target.dataset.documentId });

    Object.keys(response.data).map((el) => {
      if (el === 'id') return;
      const elementToUpdate = modal.querySelector(`.template-download#document_id_${id} .${el} input[type='checkbox']`);

      if (elementToUpdate) {
        elementToUpdate.value = response.data[el];
        elementToUpdate.checked = response.data[el];
      }
    });
  } catch (error) {
    console.error(error);
  }
};

const init = (modal) => {
  try {
    documentsCheckbox(modal);
  } catch (e) {
    errorManager(e);
  }
};

window.DocumentsPopup = {
  init: init,
};

const behavior = (args = {}) => {
  const { selector } = args;
  try {
    const modal = qs(selector);
    if (!modal) return;
    init(modal);
  } catch (e) {
    errorManager(e);
  }
};

export { behavior };
